import * as React from 'react';
import PropTypes from 'prop-types';

const Plus = ({ color }) => (
  <svg width={16} height={16}>
    <path
      d="M1.333 8h13.334M8 1.333v13.334"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
    />
  </svg>
);

Plus.propTypes = { color: PropTypes.string };
Plus.defaultProps = { color: undefined };
export default React.memo(Plus);
